<div class="onboarding-wrapper">
  <app-custom-stepper #stepper>
    @for (step of slides | async; track step) {
      <cdk-step>
        <app-onboarding-slide [slide]="step"></app-onboarding-slide>
      </cdk-step>
    }
  </app-custom-stepper>
</div>
